import Button from 'ext-ui/components/Button/Button'
import CheckmarkIcon from 'ext-ui/svg/icon/CheckmarkIcon'
import MagicalAIIcon from 'ext-ui/svg/icon/MagicalAIIcon'
import React from 'react'
import { ImageNames } from 'src/enums'
import { useColorOrGrayscaleImage } from 'src/hooks/brandHooks'
import Trns, { useTranslate } from 'src/localization/Trns'

import style from './CancelSubscription.style'

interface CancelSubscriptionInfoProps {
  onConfirm: () => void
  onCancel: () => void
}

export default function CancelSubscriptionInfo(
  props: CancelSubscriptionInfoProps,
): React.ReactElement {
  // TODO: Replace with actual features
  const listImage = useColorOrGrayscaleImage(ImageNames.List)
  const translate = useTranslate()

  const tierFeatures = [
    {
      icon: <CheckmarkIcon />,
      text: '5+ users in your organization',
    },
    {
      icon: <CheckmarkIcon />,
      text: 'Up to 500 virtual cards per month*',
    },
    {
      icon: <MagicalAIIcon />,
      text: 'Advanced receipt management',
    },
    {
      icon: <MagicalAIIcon />,
      text: 'Additional expense categories, labels and automatic coding',
    },
    {
      icon: <CheckmarkIcon />,
      text: 'Automated monthly expense reports',
    },
    {
      icon: <CheckmarkIcon />,
      text: 'QuickBooks Online integration',
    },
  ]
  return (
    <div css={style}>
      <img
        src={listImage}
        alt="list"
        className="CancelSubscription-list-image"
      />
      <div
        className="CancelSubscription-container"
        data-testid="cancel-step-info"
      >
        <div className="CancelSubscription-text">
          <div className="CancelSubscription-header">
            {translate('Are you sure?')}
          </div>
          <div className="CancelSubscription-subtext">
            {translate(
              'By moving to starter, you no longer have access to Pro features.',
            )}
          </div>
          <div className="CancelSubscription-body">
            <div className="CancelSubscription-feature-list-container">
              <div className="CancelSubscription-feature-list-header">
                {translate('Pro features you will lose:')}
              </div>
              <div className="CancelSubscription-feature-list">
                {tierFeatures.map((feature, i) => (
                  <div className="flex-row align-start" key={i}>
                    <div className="PricingCard-checklist-item-icon">
                      {feature.icon}
                    </div>
                    <div className="PricingCard-checklist-item-text">
                      <Trns source={feature.text} />
                    </div>
                  </div>
                ))}
              </div>
              <a
                href="https://www.paywithextend.com/pricing"
                className="LinkText"
                target="_blank"
                rel="noopener noreferrer"
              >
                {translate('View all Pro features')}
              </a>
              <p className="font-support-medium asterisk-text">
                {translate(
                  '*Virtual card functionality for applicable bank partners',
                )}
              </p>
            </div>
          </div>
        </div>
        <div className="CancelSubscription-button-container CancelSubscription-button-container--spread">
          <Button
            variant="no-border"
            onClick={props.onCancel}
            data-testid="cancel-info-cancel"
          >
            {translate('Cancel')}
          </Button>
          <Button onClick={props.onConfirm} data-testid="cancel-info-confirm">
            {translate('Confirm')}
          </Button>
        </div>
      </div>
    </div>
  )
}
